import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MerchantSelect from '@components/operator/MerchantSelect';
import PageHeader from '@shared/PageHeader';

import SlotForm from './components/SlotForm';

/**
 * ReplenishmentShelvesNew — 新增揀補儲位 slot 設定（獨立頁，取代原 SlotFormDrawer）。
 *
 * 為何用 <MerchantSelect>（對齊 StockTransferOrders/New.tsx）：
 *   merchantInventoryTypes 只有在 OperatorDataContext 有「當前選定 merchant」時才載入。
 *   補貨屬 Enterprise（非單一 merchant 模式）→ 單一 merchant 自動鎖定 effect 不會跑，
 *   必須由本頁的 <MerchantSelect> 建立 merchant context，inventory_type 下拉才會有選項。
 *   render-prop 把選到的 merchantId 直接交給 SlotForm。
 */
const ReplenishmentShelvesNew: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // PageHeader 放在 <MerchantSelect> render-prop 內（對齊 StockTransferOrders/New、Orders/New）：
  // MerchantSelect 會先 render「目前貨主」banner 再 render children，所以把 PageHeader 也放進
  // children，版面順序才會是 banner → 麵包屑 → 表單，與其他 New 頁一致；放在外面會變成
  // 麵包屑 → banner，順序顛倒。選 merchant 前也只顯示選擇卡片（不提前露出麵包屑）。
  return (
    <MerchantSelect>
      {({ merchantId }: { merchantId: string }) => (
        <div>
          <PageHeader
            items={[
              'replenishment',
              'replenishment.shelves',
              { label: t('operator.replenishment_shelves.form.new_title') },
            ]}
          />
          <SlotForm
            mode="new"
            merchantId={merchantId}
            onSaved={() => navigate('/replenishment_shelves')}
            onCancel={() => navigate('/replenishment_shelves')}
          />
        </div>
      )}
    </MerchantSelect>
  );
};

export default ReplenishmentShelvesNew;
